import { CdkColumnDef } from '@angular/cdk/table';
import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
  HostBinding,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ExportFilePopupComponent } from 'src/app/shared/components/export-file-popup/export-file-popup.component';
import { VesselStatusPopupComponent } from 'src/app/shared/components/vessel-status-popup/vessel-status-popup.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-port-inactive-vessels',
  templateUrl: './port-inactive-vessels.component.html',
  styleUrls: ['./port-inactive-vessels.component.scss'],
})
export class PortInactiveVesselsComponent {
  isFilterOpen = false;
  @ViewChildren(CdkColumnDef) columnDefs!: QueryList<CdkColumnDef>;
  filterForm!: FormGroup;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('table', { static: false }) table!: ElementRef;
  // paginatedData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 0;
  elements: any;
  counter = 1;
  segmentOptions: string[] = [];
  selectedSegments: string[] = [];
  cargoOperation: any;
  filteredData: any;
  selectedTab: boolean | undefined;
  pastVoyagesComponent: any;
  data: any;
  shipNameSuggestions: any[] = [];
  edit: boolean = false;
  dataToPass: any;
  snackBar: any;
  sharedDataService: any;
  paginatedData: any;
  clientOptions: string[] = [];
  selectedClients: string[] = [];
  username: any;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private requestFormService: RequestFormService,
    private prequestFormService: PortRequestFormServiceService
  ) {
    this.filterForm = this.fb.group({
      from_date: ['', [Validators.required]],
      to_date: ['', [Validators.required]],
      shipName: ['', [Validators.required]],
      imoNumber: ['', [Validators.required]],
      cargoOperation: ['', [Validators.required]],
    });
    // this.segmentOptions = getSegmentOptions();
  }
  ngOnInit() {
    this.loadData();
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  @HostBinding('class.pc-light') get pcLight(): boolean {
    return !this.isDarkMode();
  }
  refresh() {
    this.loadData();
  }
  loadData() {
    this.username = localStorage.getItem('username');
    this.prequestFormService.getFleetViewData('false').subscribe((data) => {
      const clientFilters: { [key: string]: (item: any) => boolean } = {
        'Eiger Shipping': (item) =>
          item.client === 'Northwell' || item.client.toLowerCase() === 'Eiger',
        'Zeronorth ZN': (item) => item.client.toLowerCase() === 'zeroNorth',
        'Elite Shipping': (item) => item.client.toLowerCase() === 'elite',
        'Bunge Shipping': (item) => item.client.toLowerCase() === 'bunge',
        'EMZoil Shipping': (item) =>
          item.client &&
          (item.client.toLowerCase() === 'emz oil' ||
            item.client.toLowerCase() === 'emzoil fzco' ||
            item.client.toLowerCase().includes('emz')),
      };
      if (this.username === 'Meraki - Operations') {
        data = data.data;
      } else if (clientFilters[this.username]) {
        data = data.data.filter(clientFilters[this.username]);
      }
      this.elements = data;

      // Create unique dropdown options
      this.segmentOptions = [
        ...new Set(
          this.elements.map((item: any) => item.segment).filter(Boolean),
        ),
      ] as string[];
      this.clientOptions = [
        ...new Set(
          this.elements.map((item: any) => item.client).filter(Boolean),
        ),
      ] as string[];

      this.paginateData();
    });
  }
  clearClick() {
    this.filterForm.reset();
    this.selectedSegments = [];
    this.selectedClients = [];
    this.filteredData = this.elements;
    this.paginateData();
  }

  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue.length > 0) {
      this.shipNameSuggestions = this.elements.filter((item: any) =>
        item.vessel_name.toLowerCase().includes(inputValue)
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }
  ngAfterViewInit() {
    this.sort?.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  paginateData() {
    const startIndex = this.currentPage * this.itemsPerPage;
    this.paginatedData = this.elements?.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.paginateData();
  }

  sortData(sort: Sort) {
    const data = this.paginatedData.slice();
    if (!sort.active || sort.direction === '') {
      this.paginatedData = data;
      return;
    }

    this.paginatedData = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, isAsc, sort.active);
    });
  }

  compare(a: any, b: any, isAsc: boolean, column: string) {
    let valueA = this.getNestedValue(a, column);
    let valueB = this.getNestedValue(b, column);

    if (valueA === null || valueA === undefined) return isAsc ? -1 : 1;
    if (valueB === null || valueB === undefined) return isAsc ? 1 : -1;

    const numericalColumns = ['timeLost', 'hsfo', 'vlsfo', 'go'];
    if (numericalColumns.includes(column)) {
      valueA = parseFloat(valueA);
      valueB = parseFloat(valueB);
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    }

    return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getNestedValue(obj: any, column: string) {
    switch (column) {
      case 'hsfo':
      case 'vlsfo':
      case 'go':
        return obj.bunkerLostOrGain[column.toUpperCase()];
      default:
        return obj[column];
    }
  }
  formatSegment(value: string): string {
    if (!value) return '';

    const trimmed = value.trim().toLowerCase().replace(/\s+/g, ' ');
    const match = trimmed.match(/^([a-z0-9]+)\s*(\(([^)]+)\))?$/i);

    if (match) {
      const main = match[1].toUpperCase(); // e.g., 'LR1', 'MR'
      const bracket = match[3]
        ? ` (${match[3].charAt(0).toUpperCase()}${match[3].slice(1)})`
        : '';
      return main + bracket;
    }

    // Fallback: title case
    return value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }
  showDetails(row: any) {
    // this.sharedDataService.setRowData(row);
    localStorage.setItem('pShipName', row.vessel_name);
    localStorage.setItem('pImo', row.vessel_imo);
    localStorage.setItem('pSegment', row.segment || '');
    localStorage.setItem('eyeIcon', 'yes');
    this.router.navigate(['/pc-vesselView']);
  }
  showClaimable(row: any) {
    localStorage.setItem('pShipName', row.vessel_name);
    localStorage.setItem('pImo', row.vessel_imo);
    localStorage.setItem('pSegment', row.segment || '');
    localStorage.setItem('eyeIcon', 'No');
    this.router.navigate(['/pc-vesselView']);
  }
  downloadIcon(ow: any) {
    // this.toastr.success(ToasterMessages.UnderDev);
  }

  editedRowIndex: number | null = null;
  editedColumnName: string | null = null;
  editCell(rowIndex: number, columnName: string) {
    this.editedRowIndex = rowIndex;
    this.editedColumnName = columnName;
  }
  exitEdit() {
    this.editedRowIndex = null;
    this.editedColumnName = null;
  }
  calculateClaimableAmount(element: any) {
    const claimEst = element.claimEst;
    const fuelLost = element.bunkerLostOrGain;

    if (
      claimEst === null ||
      claimEst === undefined ||
      claimEst.hire === '' ||
      claimEst.bunkPrice === ''
    ) {
      return '__';
    }
    const HSFO = fuelLost && fuelLost.HSFO === '__' ? 0 : fuelLost.HSFO;
    const VLSFO = fuelLost && fuelLost.VLSFO === '__' ? 0 : fuelLost.VLSFO;
    const GO = fuelLost && fuelLost.GO === '__' ? 0 : fuelLost.GO;
    const bunkPrice =
      claimEst && claimEst.bunkPrice !== null ? claimEst.bunkPrice : 0;
    const hireClaim = claimEst ? claimEst.hire * (element.timeLost / 24) : 0;
    const fuelClaim = fuelLost
      ? bunkPrice * (HSFO || 0) +
      bunkPrice * (VLSFO || 0) +
      bunkPrice * (GO || 0)
      : 0;

    const totalClaim = hireClaim + fuelClaim;

    return isNaN(totalClaim) || totalClaim === undefined
      ? '__'
      : Math.round(totalClaim);
  }

  filterClick() {
    let { shipName, imoNumber } = this.filterForm.value;

    shipName = shipName?.trim().toLowerCase();
    imoNumber = imoNumber?.trim().toLowerCase();

    this.filteredData = this.elements.filter((item: any) => {
      const segmentMatch =
        this.selectedSegments.length === 0 ||
        this.selectedSegments.some(
          (seg) => item.segment?.toLowerCase() === seg.trim().toLowerCase(),
        );

      const shipMatch = shipName
        ? item.vessel_name?.toLowerCase().includes(shipName)
        : true;

      const imoMatch = imoNumber
        ? item.vessel_imo?.toLowerCase().includes(imoNumber)
        : true;

      const clientMatch =
        this.selectedClients.length === 0 ||
        this.selectedClients.some((client) =>
          item.client?.toLowerCase().includes(client.trim().toLowerCase()),
        );

      return segmentMatch && shipMatch && imoMatch && clientMatch;
    });

    // Update pagination based on filtered data
    const startIndex = this.currentPage * this.itemsPerPage;
    const pageItems = this.filteredData.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );

    this.paginatedData = pageItems.map((item: any, index: number) => ({
      ...item,
      sNo: startIndex + index + 1,
    }));
    this.isFilterOpen = false;
  }

  closeFilterDrawer(): void {
    this.isFilterOpen = false;
  }

  exportClick() {
    const data = this.filteredData || this.elements;
    if (!data.length) return;

    const firstItem = data[0];
    const shipName = firstItem.vessel_name || 'UnknownShip';
    const segment = firstItem.segment || 'UnknownSegment';

    const csvHeader = [
      'Sr No',
      'Vessel Name',
      'IMO No',
      'Client',
      'Segment',
      'Warranty Variance (MT)',
      'Technical Variance (MT)',
      'CP Gain/Loss (MT)',
      'Technical Gain/Loss (MT)',
    ].join(',');

    const csvRows = data.map((item: any, index: number) => {
      return [
        index + 1,
        item.vessel_name || '',
        item.vessel_imo || '',
        item.client || '',
        this.formatSegment(item.segment) || '',
        item.performance_against_warranties?.toFixed(2) ?? '',
        item.performance_against_design?.toFixed(2) ?? '',
        this.getTotalWarrantedConsumption(item),
        this.getTotalDesignConsumption(item),
      ]
        .map((field) => `"${field}"`)
        .join(',');
    });

    const csvContent = `${csvHeader}\n${csvRows.join('\n')}`;
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Fleet_View.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }


  downloadClick() {
    // this.toastr.success(ToasterMessages.UnderDev);
  }
  tabChanged(event: MatTabChangeEvent) {
    // this.selectedTab = !this.selectedTab;
    // if (this.pastVoyagesComponent) {
    //   this.pastVoyagesComponent.refresh();
    // }
  }
  editClick() {
    // this.toastr.warning(ToasterMessages.UnderDev);
    this.edit = true;
  }

  selectedElement: any = null;

  onCheckboxChange(event: Event, element: any) {
    const checkbox = event.target as HTMLInputElement;
    const isChecked = checkbox.checked;

    if (this.selectedElement && this.selectedElement !== checkbox) {
      this.selectedElement.checked = false;
    }

    if (isChecked) {
      this.selectedElement = checkbox;

      const dialogRef = this.dialog.open(VesselStatusPopupComponent, {
        width: '400px',
        height: '228px',
        disableClose: true,
        data: { reasonOptions: element.vessel_status },
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          const payload = {
            vessel_name: element.vessel_name,
            imo: element.vessel_imo,
            reason: result.reason,
            status: result.status,
          };

          this.prequestFormService.updateStatus(payload).subscribe(
            () => {
              this.edit = false;
              this.toastr.success(ToasterMessages.SuccessMessage);
              this.loadData();
            },
            (error: any) => {
              this.toastr.error('Error updating status. Please try again.');
              console.error('Update error:', error);
            }
          );
        } else {
          // If the dialog is closed without selecting a value, uncheck the checkbox
          checkbox.checked = false;
          this.selectedElement = null;
        }
      });
    } else {
      this.selectedElement = null;
    }
  }
  getTotalWarrantedConsumption(element: any): string {
    const total =
      (element.cp_warranted_loss_or_gain_hsfo || 0) +
      (element.cp_warranted_loss_or_gain_lsgo || 0) +
      (element.cp_warranted_loss_or_gain_vlsfo || 0);

    return total.toFixed(2);
  }
  getTotalDesignConsumption(element: any) {
    const total =
      (element.technical_design_loss_or_gain_hsfo || 0) +
      (element.technical_design_loss_or_gain_lsgo || 0) +
      (element.technical_design_loss_or_gain_vlsfo || 0);

    return total.toFixed(2);
  }

  private getCpLossGainTotal(element: any): number {
    return (
      (element.cp_warranted_loss_or_gain_hsfo || 0) +
      (element.cp_warranted_loss_or_gain_lsgo || 0) +
      (element.cp_warranted_loss_or_gain_vlsfo || 0)
    );
  }

  private getTechnicalLossGainTotal(element: any): number {
    return (
      (element.technical_design_loss_or_gain_hsfo || 0) +
      (element.technical_design_loss_or_gain_lsgo || 0) +
      (element.technical_design_loss_or_gain_vlsfo || 0)
    );
  }

  getCpLossGainStyle(element: any): { [klass: string]: string } {
    const total = this.getCpLossGainTotal(element);
    return {
      color: total < 0 ? '#ff9090' : total > 0 ? '#a8d296' : 'inherit',
    };
  }

  getTechnicalLossGainStyle(element: any): { [klass: string]: string } {
    const total = this.getTechnicalLossGainTotal(element);
    return {
      color: total < 0 ? '#ff9090' : total > 0 ? '#a8d296' : 'inherit',
    };
  }

  getWarrantedStyle(element: any): { [klass: string]: any } {
    const total = element.performance_against_warranties;
    return {
      'color':
        total < 0 ? '#ff9090' : total > 0 ? '#a8d296' : 'null',

    };
  }
  getTotalDesignStyle(element: any) {
    const total = element.performance_against_design;

    return {
      'color':
        total < 0 ? '#ff9090' : total > 0 ? '#a8d296' : 'null',

    };
  }

  getWarrantedTooltip(element: any): string {
    return (
      `Maneuvering: ${element.maneuvering_performance_against_warranties_mt?.toFixed(2) ||
      '0.00'
      }\n` +
      `Idle: ${element.idle_performance_against_warranties_mt?.toFixed(2) || '0.00'
      }\n` +
      `Cargo Ops: ${element.cargo_ops_performance_against_warranties_mt?.toFixed(2) ||
      '0.00'
      }`
    );
  }

  getDesignTooltip(element: any): string {
    return (
      `Maneuvering: ${element.maneuvering_performance_against_design_mt?.toFixed(2) || '0.00'
      }\n` +
      `Idle: ${element.idle_performance_against_design_mt?.toFixed(2) || '0.00'
      }\n` +
      `Cargo Ops: ${element.cargo_ops_performance_against_design_mt?.toFixed(2) || '0.00'
      }`
    );
  }
  formatVesselName(name: string): string {
    if (!name) return '';

    return name
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim().length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }





  private segmentColorMap: { [key: string]: string } = {
    mr: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }
}
